import { Typography, TypographyProps } from '@mui/material';

export const PositionDetailSecondaryTypography = ({ children, ...rest }: TypographyProps) => {
  return (
    <Typography variant="body1.semibold" {...rest}>
      {children}
    </Typography>
  );
};
